
/**
 * @export
 * @enum {string}
 */
export enum PaperFormat {
    LETTER = 'LETTER',
    A4 = 'A4'
}